import axios from "axios";
import { api, headers } from "../../app/conf";

export const getCustomAttributesService = (token, ticketId, parentType, visible) => {
    let url = `${api}/v1/customAttributes`;
    const params = new URLSearchParams();
    
    if (parentType) {
        params.append('parentType', parentType);
    }
    
    if (visible !== undefined && visible !== null) {
        params.append('visible', visible);
    }
    
    if (params.toString()) {
        url += `?${params.toString()}`;
    }
    
    return axios({
        method: "get",
        url,
        headers: {
            ...headers,
            "access-token": token,
        },
    });
};